import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PhoneIcon } from "../../../images/learnersimage/phoneicon.svg";
import { ReactComponent as NameIcon } from "../../../images/learnersimage/nameicon.svg";
import { ReactComponent as EmailIcon } from "../../../images/learnersimage/emailicon.svg";
import { Autocomplete } from "@material-ui/lab";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

function AddCenterForm() {
  const classes = useStyles();

  const initialData = {
    center_name: "",
    center_code: "",
    phone: "",
    email: "",
    contact_person_name: "",
    // address: "",
    // city: "",
    // state: "",
    // pincode: "",
    password: "",
    course_id: "",
    batch_id: "",
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [pincodeError, setPincodeError] = useState(false);
  const [pincodeErrorMessage, setPincodeErrorMessage] = useState("");

  const [formDetails, setFormDetails] = useState(initialData);
  const [centerName, setCenterName] = useState("");

  const [selectedState, setSelectedState] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [states, setStates] = useState([]);

  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");

  // State for student email error
  const [emailError, setEmailError] = useState(false);

  // New state_id for phone number error message
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");
  // New state_id for phone number error
  const [phoneError, setPhoneError] = useState(false);

  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");

  const fetchCources = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        setCources(data.courses);
      } else {
        console.error("Failed to fetch courses data");
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  useEffect(() => {
    fetchCources();
  }, []);

  const handleCourceChange = (event, newValue) => {
    setSelectedCourse(newValue.map((cource) => cource.id));
  };

  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCourse.length > 0) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,

          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              batch: {
                course_ids: selectedCourse,
              },
            }),
          },
        );
        if (response.ok) {
          const data = await response.json();
          setBatches(data.batches);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchBatches(selectedCourse);
  }, [selectedCourse]);

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue.map((batch) => batch.id));
  };

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
    console.log("Password visibility toggled:", !showPassword); // Debugging
  };

  const handleClose = () => {
    navigate("/admin/center");
  };

  // const fetchStates = async () => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state`,
  //       {
  //         method: "GET",
  //       },
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setStates(data.states);
  //     } else {
  //       console.error("Failed to fetch categories data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching categories data:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchStates();
  // }, []);

  // const fetchDistricts = async (selectedStateId) => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state/${selectedStateId}`,
  //       {
  //         method: "GET",
  //       },
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setDistricts(data.cities);
  //     } else {
  //       console.error("Failed to fetch categories data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching categories data:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchDistricts(selectedStateId);
  // }, [selectedStateId]);

  // Function to validate email
  const validateEmail = (email) => {
    // Standard email regex pattern
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (email) => {
    if (!validateEmail(email)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    handleFormChange("email", email); // Assuming your state_id field is named 'studentEmail'
  };

  // const handleStateChange = (event, value) => {
  //   setSelectedState(value);
  //   setSelectedStateId(value.id);
  // };
  // const handleDistrictChange = (event, value) => {
  //   setSelectedDistrict(value);
  //   setSelectedDistrictId(value.id);
  // };

  // Updated phone field handler
  const handlePhoneChange = (value) => {
    const digitsOnly = value.replace(/\D/g, "");

    // Reject invalid starting digits immediately
    if (digitsOnly.length > 0 && !/^[6789]/.test(digitsOnly)) {
      setPhoneError(true);
      setPhoneErrorMessage("Phone number must start with 6, 7, 8, or 9.");
      return;
    }

    // Prevent more than 10 digits
    if (digitsOnly.length > 10) {
      return;
    }

    handleFormChange("phone", digitsOnly);

    if (digitsOnly === "") {
      setPhoneError(false);
      setPhoneErrorMessage("");
    } else if (digitsOnly.length !== 10) {
      setPhoneError(true);
      setPhoneErrorMessage(
        "Phone number must be exactly 10 digits",
      );
    } else {
      setPhoneError(false);
      setPhoneErrorMessage("");
    }
  };

  const handleFormChange = (fieldName, value) => {
    // if (fieldName === "pincode") {
    //   if (value.length === 6) {
    //     setPincodeError(false);
    //     setPincodeErrorMessage("");
    //   } else {
    //     setPincodeError(true);
    //     setPincodeErrorMessage("Pincode must be exactly 6 digits");
    //   }
    //   // Update the pincode value only if it's 6 digits or less
    //   if (value.length <= 6) {
    //     setFormDetails((prevFormDetails) => ({
    //       ...prevFormDetails,
    //       [fieldName]: value,
    //     }));
    //   }
    // } else {
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        [fieldName]: value,
      }));
    // }
  };

  const handleFormSubmit = async () => {
    // Reset password error state before validation
    setPasswordError(false);
    setPasswordErrorMessage("");
    console.log("emailErroradd", emailError);
    // Other validations as before..
    if (
      !centerName.trim() ||
      !formDetails?.center_code?.trim() ||
      !formDetails?.contact_person_name?.trim() ||
      !formDetails?.phone?.trim() ||
      emailError ||
      !formDetails?.password?.trim() ||
      (typeof selectedCourse === "string" && !selectedCourse.trim()) ||
      (typeof selectedBatch === "string" && !selectedBatch.trim()) 
      // ||
      // (typeof selectedStateId === "string" && !selectedStateId.trim()) ||
      // (typeof selectedDistrictId === "string" && !selectedDistrictId.trim())
    ) {
      if (!centerName.trim()) {
        toast.warn("Please enter a Branch name.");
      } else if (!formDetails?.center_code?.trim()) {
        toast.warn("Please enter center code.");
      } else if (!formDetails?.contact_person_name?.trim()) {
        toast.warn("Please enter contact person name.");
      } else if (!formDetails?.phone?.trim()) {
        toast.warn("Please enter a phone number.");
      } else if (emailError) {
        toast.warn("Please enter a valid email address");
      } else if (!formDetails?.email?.trim()) {
        toast.warn("Please enter an email.");
      } else if (!formDetails?.password?.trim()) {
        toast.warn("Please enter a password.");
      } else if (typeof selectedCourse === "string" && !selectedCourse.trim()) {
        toast.warn("Please select a course.");
      } else if (typeof selectedBatch === "string" && !selectedBatch.trim()) {
        toast.warn("Please select a batch.");
      }
      //  else if (
      //   typeof selectedStateId === "string" &&
      //   !selectedStateId.trim()
      // ) {
      //   toast.warn("Please select a state.");
      // } else if (
      //   typeof selectedDistrictId === "string" &&
      //   !selectedDistrictId.trim()
      // ) {
      //   toast.warn("Please select a city.");
      // }

      return;
    }

    // Check for phone validation error
    if (phoneError || !/^[6789]\d{9}$/.test(formDetails.phone)) {
      toast.warn(
        "Please enter a valid mobile number (10 digits starting with 6, 7, 8, or 9).",
      );
      return;
    }

    // Validate password length
    if (formDetails.password.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Password must be at least 6 characters long");
      toast.warn("Password must be at least 6 characters long");
      return; // Prevent form submission
    }

    const data = {
      center: {
        center_name: centerName,
        center_code: formDetails.center_code,
        phone: formDetails.phone,
        email: formDetails.email,
        contact_person_name: formDetails.contact_person_name,
        // address: formDetails.address ? formDetails.address : null,
        // state: selectedStateId ? selectedStateId : null,
        // city: selectedDistrictId ? selectedDistrictId : null,
        // pincode: formDetails.pincode ? formDetails.pincode : null,
        password: formDetails.password,
        course_id: selectedCourse,
        batch_id: selectedBatch,
      },
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      )
      .then((response) => {
        toast.success("Branch created successfully");
        setTimeout(() => {
          navigate("/admin/center");
        }, 2000);
      })
      .catch((error) => {
        console.log("objecterror", error.response);
        toast.error(error.response.data.error);
      });
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Branch Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setCenterName(e.target.value)}
                  value={centerName}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Branch Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formDetails.center_code}
                  onChange={(e) =>
                    handleFormChange("center_code", e.target.value)
                  }
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Branch Code"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Contact Person Name{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formDetails.contact_person_name}
                  onChange={(e) =>
                    handleFormChange("contact_person_name", e.target.value)
                  }
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Contact Person Name"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <NameIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Mobile No. <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formDetails.phone}
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="91XXXXXXXX"
                  inputProps={{ maxLength: 10 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display error message for phone */}
                {phoneError && (
                  <Typography color="error" className={classes.errorMessage}>
                    {phoneErrorMessage}
                  </Typography>
                )}
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Email Address <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => handleEmailChange(e.target.value)}
                  value={formDetails.email}
                  type="email"
                  variant="outlined"
                  required
                  placeholder="Enter Email Address"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display error message for student email */}
                {emailError && (
                  <Typography color="error" className={classes.errorMessage}>
                    Please enter a valid email address
                  </Typography>
                )}
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Create Password{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  required
                  placeholder="********"
                  value={formDetails.password}
                  onChange={(e) => handleFormChange("password", e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleToggleShowPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={cources}
                  getOptionLabel={(option) => option.course_name}
                  value={cources.filter((cou) =>
                    selectedCourse.includes(cou.id),
                  )}
                  onChange={handleCourceChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick Course..."
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((bat) =>
                    selectedBatch.includes(bat.id),
                  )}
                  onChange={handleBatchChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick Batch..."
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>

            {/* <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Address
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w74} `}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1}
                 ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Address
                </FormLabel>
                <TextField
                  value={formDetails.address}
                  onChange={(e) => handleFormChange("address", e.target.value)}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Type Here"
                  multiline
                  rows={6}
                />
              </div>
            </div> */}
            {/* <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  State <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={states || []}
                  value={selectedState}
                  onChange={handleStateChange}
                  disableClearable
                  getOptionLabel={(option) => option.name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select State"
                      variant="outlined"
                      {...params}
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  City <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="district_id"
                  options={districts || []}
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                  disableClearable
                  getOptionLabel={(option) => option.name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select City"
                      variant="outlined"
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Pincode
                </FormLabel>
                <TextField
                  name="pincode"
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Pincode"
                  value={formDetails.pincode}
                  onChange={(e) => handleFormChange("pincode", e.target.value)}
                  error={pincodeError}
                  helperText={pincodeError ? pincodeErrorMessage : ""}
                  inputProps={{ maxLength: 6, pattern: "\\d*" }}
                />
              </div>
            </div> */}
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddCenterForm;
